export default __webpack_public_path__ + "static/plinth2016-7f51762faec48779e67b449ed4574efd.jpg";